import L from "leaflet";
import { PATHFINDER_COLOR } from "@/utils/routeHelper";

const SIZE = 28;
const C = SIZE / 2;

// Same ring for both icons; the center marks the action (dot = editable
// waypoint, plus = insert-on-line). White underlay gives the 0.5px edge.
const ringIcon = (center, className) =>
  L.divIcon({
    className,
    html: `<svg width="${SIZE}" height="${SIZE}" viewBox="0 0 ${SIZE} ${SIZE}" style="display:block">
    <circle cx="${C}" cy="${C}" r="9" fill="none" stroke="white" stroke-width="2.5" />
    <circle cx="${C}" cy="${C}" r="9" fill="none" stroke="${PATHFINDER_COLOR}" stroke-width="1.5" />
    ${center}
  </svg>`,
    iconSize: [SIZE, SIZE],
    iconAnchor: [C, C],
  });

export const editWaypointIcon = ringIcon(
  `<circle cx="${C}" cy="${C}" r="3" fill="${PATHFINDER_COLOR}" stroke="white" stroke-width="1" />`,
  "css-icon wp-edit-marker",
);

const plusPath = `M${C - 5.5} ${C} H${C + 5.5} M${C} ${C - 5.5} V${C + 5.5}`;
export const insertWaypointIcon = ringIcon(
  `<path d="${plusPath}" fill="none" stroke="white" stroke-width="2.5" />
    <path d="${plusPath}" fill="none" stroke="${PATHFINDER_COLOR}" stroke-width="1.5" />`,
  // Follows the cursor non-interactively, so no hover class.
  "css-icon",
);
